// tslint:disable:no-unsafe-any (autogenerated)
// tslint:disable:no-string-literal (autogenerated)
// tslint:disable:no-any (autogenerated)
import * as React from 'react';
import Radium from '../../styling/rostelecom-radium';
import InternationalizedComponent from '../../../../base/internationalized-component';
import { IRostelecomStyleParamsStoreState } from '../../styling/rostelecom-styles-store';
import { IWindowSizeStoreState } from '../../../../../services/window-size/window-size-store';
import {
    getPropsForField,
    validateOnFormSubmit,
    processInitialValidation
} from '../../../../../services/forms/form-helper';
import { ILoginStoreState } from '../../../../../services/login/login-store';
import * as loginActions from '../../../../../services/login/login-actions';
import { startApp } from '../../../../../bootstrap/updated/auth-page';
import Checkbox from '../../reusable/checkbox';
import LoginInput from './elements/login-input';
import LoginPasswordInput from './elements/login-password-input';
import LoginButton from './elements/login-button';
import queryString from 'query-string';
import { changeQueryString, getErrorMessageFromQueryString } from '../../../pdg/pages/change-query-string';

export interface ILoginPageProps {
    styleParams: IRostelecomStyleParamsStoreState;
    windowSize: IWindowSizeStoreState;
    loginStore?: ILoginStoreState;
}

export interface ILoginPageState {
    formState?: any;
    errorMessage?: string;
}

@Radium
class LoginPage extends InternationalizedComponent<ILoginPageProps, ILoginPageState> {
    private _form: HTMLFormElement;

    // tslint:disable-next-line:typedef (autogenerated)
    constructor(props, opts) {
        super(props, opts);
        this.doAuthorize = this.doAuthorize.bind(this);
        this.initialize();
    }

    public componentDidMount(): void {
        super.componentDidMount();
        const errorMessage = getErrorMessageFromQueryString();
        if (errorMessage) {
            this.setState({
                errorMessage
            });
            const searchParams = queryString.parse(location.search);
            delete searchParams.errorMessage;
            changeQueryString(queryString.stringify(searchParams));
        }
    }

    private getStyles(): { [style: string]: React.CSSProperties } {
        const styleParams = this.props.styleParams;
        const login = this.props.loginStore;
        const visible = login.page === 'login';
        return {
            form: {
                position: visible ? 'relative' : 'absolute',
                zIndex: visible ? 20 : 0,
                opacity: visible ? 1 : 0,
                top: 0,
                left: 0,
                width: '100%',
                transition: 'opacity 0.15s ease-out, z-index 0.15s ease-out'
            },
            checkboxOuter: {
                position: 'relative',
                textAlign: 'left'
            },
            buttonsOuter: {},
            linkStyle: {
                marginTop: 20,
                display: 'block',
                color: styleParams.complementaryMediumDarkColor
            },
            serverError: {
                display: 'block',
                color: styleParams.baseAccentColor,
                minHeight: 16,
                lineHeight: '16px',
                fontSize: '14px',
                marginTop: 8,
                marginBottom: 8
            }
        };
    }

    // tslint:disable-next-line:member-ordering (autogenerated)
    private formFields: IFormFieldDescriptor[] = [
        {
            id: 'login',
            validate: (value, oldValue) => {
                if (!value || value.length === 0) {
                    return [this.i18n('js.auth.pages.login.fields.login.required')];
                }
                return [];
            }
        },
        {
            id: 'password',
            validate: (value, oldValue) => {
                if (!value || value.length === 0) {
                    return [this.i18n('js.auth.pages.login.fields.password.required')];
                }
                return [];
            }
        },
        {
            id: 'remember'
        }
    ];

    private getFormDescriptor = (): IFormDescriptor => {
        return {
            value: this.props.loginStore,
            state: this.state.formState,
            onChange: value => {
                loginActions.setLoginState(value);
            },
            onStateChange: state => {
                this.setState({ formState: state });
            },
            fields: this.formFields
        };
    };

    // tslint:disable-next-line:typedef (autogenerated)
    private async doAuthorize(evt) {
        if (evt && evt.preventDefault) {
            evt.preventDefault();
        }
        this.setState({
            errorMessage: ''
        });
        const form = this.getFormDescriptor();

        // Bug #18009. Chrome's auto form filling workaround
        const login = this._form.elements['login'].value;
        const password = this._form.elements['password'].value;

        // tslint:disable-next-line:prefer-object-spread (autogenerated)
        const newValue = Object.assign({}, form.value, { login, password });

        const newFormState = processInitialValidation(form);

        form.onStateChange(newFormState, form.state);
        form.onChange(newValue, form.value, 'login');
        form.value = newValue;

        if (validateOnFormSubmit(form, newValue)) {
            try {
                const res = await loginActions.authorize(
                    newValue.login,
                    newValue.password,
                    newValue.remember
                );
                if (res.success) {
                    // start main app
                    startApp();
                }
            } finally {
            }
        }
    }

    // tslint:disable-next-line:typedef member-access (autogenerated)
    goToRestore = evt => {
        loginActions.setPage('restore-password');
        if (evt && evt.preventDefault) {
            evt.preventDefault();
            evt.stopPropagation();
        }
    };

    public render(): JSX.Element {
        const styles = this.getStyles();
        const styleParams = this.props.styleParams;
        const login = this.props.loginStore;
        const form = this.getFormDescriptor();
        const loginProps = getPropsForField(form, 'login');
        const passwordProps = getPropsForField(form, 'password');
        const rememberProps = getPropsForField(form, 'remember');
        const disabled =
            login.authorizing ||
            login.authorized ||
            login.resettingPassword ||
            login.restoringPassword;

        return (
            <form
                key="loginRoot"
                onSubmit={this.doAuthorize}
                style={styles.form}
                ref={newForm => (this._form = newForm)}
            >
                <LoginInput
                    key="login"
                    {...{
                        formProps: loginProps,
                        styleParams,
                        disabled
                    }}
                />
                <LoginPasswordInput
                    key="password"
                    {...{
                        type: 'password',
                        formProps: passwordProps,
                        styleParams,
                        disabled
                    }}
                />
                <div key="remember" style={styles.checkboxOuter}>
                    <Checkbox
                        {...rememberProps}
                        disabled={disabled}
                        display={this.i18n('js.auth.pages.login.fields.remember.label')}
                        styles={styleParams}
                    />
                </div>
                <div key="buttons" style={styles.buttonsOuter}>
                    <div key="serverError" style={styles.serverError}>
                        {(login && login.authorizationError) || this.state.errorMessage}
                    </div>
                    <LoginButton
                        {...{
                            disabled,
                            styleParams,
                            onClick: this.doAuthorize,
                            label: this.i18n('js.auth.pages.login.buttons.authorize')
                        }}
                    />
                </div>
                <a key="restore-pass" style={styles.linkStyle} href="#" onClick={this.goToRestore}>
                    {this.i18n('js.auth.pages.login.buttons.go-to-restore-password')}
                </a>
            </form>
        );
    }
}

// tslint:disable-next-line:no-default-export (autogenerated)
export default LoginPage;
